import { Directive, ElementRef, forwardRef, HostListener, Input, Renderer2 } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RutHelper } from "src/app/helpers/rut.helper";

export function formatToRut(preRutString: string): string {
	return RutHelper.format(preRutString);
}

@Directive({
	selector: "input[appFormatRut]",
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormatRutDirective), multi: true }],
})
export class FormatRutDirective implements ControlValueAccessor {
	@Input() appFormatRut: boolean | string = true;
	private onChange: (value: string) => void = () => {};
	private onTouched: () => void = () => {};

	constructor(private element: ElementRef<HTMLInputElement>, private renderer: Renderer2) {}

	writeValue(value: string): void {
		this.renderer.setProperty(this.element.nativeElement, "value",
			this.appFormatRut === false ? value || "" : RutHelper.formatInput(value));
	}

	@HostListener("input")
	onInput(): void {
		const input = this.element.nativeElement;
		if (this.appFormatRut === false) {
			this.onChange(input.value);
			return;
		}
		const cursor = input.selectionStart;
		const charsBeforeCursor = input.value.slice(0, cursor ?? input.value.length).replace(/[^0-9kK]/g, "").length;
		const formatted = RutHelper.formatInput(input.value);
		this.renderer.setProperty(input, "value", formatted);
		if (cursor !== null) {
			let position = 0;
			let count = 0;
			while (position < formatted.length && count < charsBeforeCursor) {
				if (/[0-9K]/.test(formatted[position])) count++;
				position++;
			}
			input.setSelectionRange(position, position);
		}
		this.onChange(formatted.replace(/\./g, ""));
	}

	@HostListener("blur")
	onBlur(): void { this.onTouched(); }
	registerOnChange(fn: (value: string) => void): void { this.onChange = fn; }
	registerOnTouched(fn: () => void): void { this.onTouched = fn; }
	setDisabledState(disabled: boolean): void { this.renderer.setProperty(this.element.nativeElement, "disabled", disabled); }
}
